import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["page", "dot", "prev", "next"]
  static values  = { current: { type: Number, default: 0 } }

  connect() { this.update() }

  next() {
    if (this.currentValue < this.pageTargets.length - 1) this.currentValue++
  }

  prev() {
    if (this.currentValue > 0) this.currentValue--
  }

  goTo(event) {
    this.currentValue = parseInt(event.currentTarget.dataset.page)
  }

  currentValueChanged() { this.update() }

  update() {
    const cur = this.currentValue
    const total = this.pageTargets.length

    this.pageTargets.forEach((el, i) => el.hidden = i !== cur)
    this.dotTargets.forEach((el, i) => {
      el.classList.toggle("bg-primary",  i === cur)
      el.classList.toggle("bg-gray-300", i !== cur)
    })

    if (this.hasPrevTarget) this.prevTarget.disabled = cur === 0
    if (this.hasNextTarget) this.nextTarget.disabled = cur === total - 1
  }
}
